/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

import { Flow, FlowModule } from '@store/async';
import { apiClient } from '@store/index';
import { axiosErrorMiddleware } from '../common';
import { QueryFunctionContext } from '@tanstack/react-query';
import { SaveWorkflowType, WorkflowDataParams } from './';
import { WorkflowData } from '@common/hooks/types';

export const listWorkflows = async ({
  queryKey,
}: QueryFunctionContext<[string, string | undefined]>): Promise<Flow[]> => {
  const [, service_id] = queryKey;

  const url = `/${service_id}/workflows`;
  const response = await apiClient.get(url);

  if (response?.data) return response.data as Flow[];
  return [];
};

export const listModules = async ({
  queryKey,
}: QueryFunctionContext<[string, string | undefined]>): Promise<FlowModule[]> => {
  const [, service_id] = queryKey;

  const url = `/${service_id}/workflows/modules`;
  const response = await apiClient.get(url);

  if (response?.data?.error) return response.data;
  return response?.data as FlowModule[];
};

export const getWorkflowData = async ({ workflow_id, service_id }: WorkflowDataParams): Promise<WorkflowData> => {
  const url = `/${service_id}/workflows/${workflow_id}`;
  const response = await apiClient.get<WorkflowData>(url);
  if (response?.data) return response?.data;
  throw new Error('An unexpected error occurred retrieving your workflow.');
};

export const saveWorkflow = async (params: SaveWorkflowType) => {
  const { config, username, service_id, service_path, trigger_type, authentication, data_prefixes } = params;
  if (!config) return;

  try {
    const body = {
      ...config,
      service_id,
      created_by: username,
      service_path,
      trigger_type,
      authentication,
      data_prefixes,
    };

    const url = `/${service_id}/workflows/${config.flow_id}`;
    const response = await apiClient.post(url, body);

    if (response?.data) return { flow_id: config.flow_id, data: response?.data };
    return { flow_id: config.flow_id, data: response?.data, error: null };
  } catch (e) {
    if (axios.isAxiosError(e)) return axiosErrorMiddleware(e);

    return {
      flow_id: config.flow_id,
      data: [],
      error: 'An unexpected error occured when communicating with the service. Your workflow has NOT been saved.',
    };
  }
};

export const deleteWorkflow = async ({ workflow_id, service_id }: { workflow_id: string; service_id: string }) => {
  try {
    const url = `/${service_id}/workflows/${workflow_id}`;
    const response = await apiClient.delete(url);
    if (response?.data) return { ...response?.data, workflow_id };
    return [];
  } catch (error) {
    return axiosErrorMiddleware(error);
  }
};
